"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var redux_1 = require("redux");
var web3_reducer_1 = require("./reducers/web3-reducer");
var wallet_reducer_1 = require("./reducers/wallet-reducer");
var reducer = (0, redux_1.combineReducers)({
  web3Reducer: web3_reducer_1["default"],
  walletReducer: wallet_reducer_1["default"]
});
var store = (0, redux_1.legacy_createStore)(reducer);
exports["default"] = store;